export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2306_36820)">
                <path
                    d="M29.25 15.125H30.9375C31.8695 15.125 32.625 15.8805 32.625 16.8125V25.8125C32.625 26.7445 31.8695 27.5 30.9375 27.5H5.0625C4.13052 27.5 3.375 26.7445 3.375 25.8125V16.8125C3.375 15.8805 4.13052 15.125 5.0625 15.125H18"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11.25 27.5H6.75V29.75H11.25V27.5Z" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M29.25 27.5H24.75V29.75H29.25V27.5Z" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M23.625 21.875C26.7317 21.875 29.25 19.3567 29.25 16.25C29.25 13.1433 26.7317 10.625 23.625 10.625C20.5183 10.625 18 13.1433 18 16.25C18 19.3567 20.5183 21.875 23.625 21.875Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeMiterlimit="10"
                />
                <path d="M15.75 9.5L16.9307 10.6807" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19.125 7.25L19.8288 8.76507" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.625 6.125V7.79584" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M31.5562 9.5L30.375 10.6807" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M27.7038 7.25L27 8.76507" stroke="black" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2306_36820">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
